import { SystemRole } from '@/api/requests/users';
import omit from 'lodash.omit';
export const getFullName = ({ firstName, lastName, }) => `${firstName} ${lastName}`;
export const getRoleTranslationKey = (userRole) => userRole.toLowerCase().replaceAll('_', '-');
export const filterRolesByExclusion = (rolesToOmit) => {
    return Object.values(omit(SystemRole, rolesToOmit));
};
